// @ts-check

/**
 * @param {import("@tanstack/react-table").Table<any>} table
 * @param {string} columnId
 * @returns {number}
 */
export function getTableColumnSumValue(table, columnId) {
  return table.getRowModel().rows.reduce(
    /**
     * @param {number} sum
     * @param {import("@tanstack/react-table").Row<any>} row
     * @returns {number}
     */
    (sum, row) => {
      if (row.getIsGrouped()) {
        return sum
      }

      const value = Number(row?.original?.[columnId])

      return sum + (isNaN(value) ? 0 : value)
    },
    0
  )
}
